import React, { useState } from "react";
import DashboardLayout from "./DashboardLayout";
import axios from "axios";

const faqs = [
  {
    question: "How do I add my business?",
    answer: "Go to the 'My Businesses' section and click 'Add Business'. Fill out the required details and submit."
  },
  {
    question: "How can I upgrade my subscription?",
    answer: "Visit the Subscription/Billing page and select your desired plan."
  },
  {
    question: "How do I reset my password?",
    answer: "Go to Profile Settings and use the 'Change Password' form."
  },
  // Add more FAQs as needed
];

const docs = [
  { title: "Getting Started Guide", url: "/docs/getting-started.pdf" },
  { title: "How to Manage Your Business", url: "/docs/manage-business.pdf" },
  { title: "FAQ Document", url: "/docs/faq.pdf" },
  // Add more documentation/tutorial links as needed
];

const DashboardSupport = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");
    try {
      await axios.post("/api/raise_ticket.php", form);
      setSubmitted(true);
    } catch {
      setError("Failed to submit your request. Please try again.");
    }
  };

  return (
    <DashboardLayout>
      <div style={{ maxWidth: 800, margin: "0 auto" }}>
        <h2>Support & Help Center</h2>

        {/* FAQs */}
        <section>
          <h4>Frequently Asked Questions</h4>
          <div className="accordion" id="faqAccordion">
            {faqs.map((faq, idx) => (
              <div className="accordion-item" key={idx}>
                <h2 className="accordion-header" id={`heading${idx}`}>
                  <button
                    className={`accordion-button${idx !== 0 ? " collapsed" : ""}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${idx}`}
                    aria-expanded={idx === 0 ? "true" : "false"}
                    aria-controls={`collapse${idx}`}
                  >
                    {faq.question}
                  </button>
                </h2>
                <div
                  id={`collapse${idx}`}
                  className={`accordion-collapse collapse${idx === 0 ? " show" : ""}`}
                  aria-labelledby={`heading${idx}`}
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">{faq.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <hr />

        {/* Contact Form */}
        <section>
          <h4>Contact Support / Raise a Ticket</h4>
          {submitted ? (
            <div className="alert alert-success">Your request has been submitted. We'll get back to you soon!</div>
          ) : (
            <form onSubmit={handleSubmit} style={{ maxWidth: 500 }}>
              <div className="mb-2">
                <label>Name</label>
                <input name="name" value={form.name} onChange={handleChange} className="form-control" required />
              </div>
              <div className="mb-2">
                <label>Email</label>
                <input name="email" type="email" value={form.email} onChange={handleChange} className="form-control" required />
              </div>
              <div className="mb-2">
                <label>Subject</label>
                <input name="subject" value={form.subject} onChange={handleChange} className="form-control" required />
              </div>
              <div className="mb-2">
                <label>Message</label>
                <textarea name="message" value={form.message} onChange={handleChange} className="form-control" rows={4} required />
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              <button type="submit" className="btn btn-primary">Submit</button>
            </form>
          )}
        </section>

        <hr />

        {/* Documentation / Tutorials */}
        <section>
          <h4>Documentation & Tutorials</h4>
          <ul>
            {docs.map((doc, idx) => (
              <li key={idx}>
                <a href={doc.url} target="_blank" rel="noopener noreferrer">{doc.title}</a>
              </li>
            ))}
          </ul>
        </section>

        <hr />

        {/* Live Chat (Optional) */}
        <section>
          <h4>Live Chat</h4>
          <p>
            {/* Placeholder for live chat widget */}
            {/* Example: <div id="tawkto-chat-widget"></div> */}
            Live chat coming soon!
          </p>
        </section>
      </div>
    </DashboardLayout>
  );
};

export default DashboardSupport; 